export default __webpack_public_path__ + "static/media/dispatcher.c89c0cc2.svg";